module.exports = __webpack_public_path__ + "img/lg_ring_r_0_0_null@3x.bdf8d3d4.png";